import type {SeedQuestionSource, SeedQuestionStatus} from '@cp/model';
import type {SeedQuestion} from '@cp/model';
import {doc, updateDoc} from 'firebase/firestore';
import {COLLECTION_EXAM_MODULE} from '@cp/model';
import {firebaseFirestore} from '../../config/firebase';
import getSeedQuestionDoc from './getSeedQuestionDoc';

const SUBCOLLECTION_SEED_QUESTION = 'seedQuestions';

export interface UpdateSeedQuestionDocInput {
  questionText?: string;
  topic?: string;
  options?: string[];
  answer?: string;
  source?: SeedQuestionSource;
  status?: SeedQuestionStatus;
}

export default async function updateSeedQuestionDoc(
  moduleId: string,
  seedQuestionId: string,
  input: UpdateSeedQuestionDocInput,
): Promise<SeedQuestion> {
  const ref = doc(firebaseFirestore, COLLECTION_EXAM_MODULE, moduleId, SUBCOLLECTION_SEED_QUESTION, seedQuestionId);
  await updateDoc(ref, {...input});
  return getSeedQuestionDoc(moduleId, seedQuestionId);
}
